import App from './App'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import './index.css'
import { registerServiceWorker } from './serviceWorkerRegistration'
import { store } from './store'

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
